import React, { lazy } from 'react';
import { motion } from 'framer-motion';
type Testimonial = {
  name: string;
  role: string;
  avatar: string;
  quote: string;
  highlight: string;
};
const testimonials: Testimonial[] = [{
  name: 'Mads Jensen',
  role: '🇩🇰 U12 Træner',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=faces',
  quote: 'Før brugte jeg to timer hver aften på at udtænke træningen. Med Håndbold Klar ankommer jeg til klubben med en færdig session, og de unge rykker sig meget hurtigere.',
  highlight: 'Jeg fik mine aftener tilbage på en uge.'
}, {
  name: 'Lars Nielsen',
  role: '🇩🇰 Idrætslærer',
  avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&h=200&fit=crop&crop=faces',
  quote: 'Sessionerne pr. kategori er guld værd. Hele mit skoleforløb er planlagt, og forældrene har bemærket forskellen til kampene.',
  highlight: 'Hele sæsonen er planlagt.'
}, {
  name: 'Thomas Sørensen',
  role: '🇩🇰 U15 Træner',
  avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=faces',
  quote: 'Målmandsmanualen låste op for noget, jeg har udskudt i årevis. Mine målmænd har rykket sig enormt på kun 2 måneder.',
  highlight: 'Mine målmænd har ændret sig totalt.'
}, {
  name: 'Camilla B.',
  role: '🇩🇰 U10 Træner',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop&crop=faces',
  quote: 'Det jeg sætter mest pris på er HD-tavlen. Jeg printer, markerer, og pigerne forstår handlingen med det samme. Det er 10 gange mere værd, end hvad jeg betalte.',
  highlight: 'Det er 10 gange mere værd.'
}, {
  name: 'Oliver L.',
  role: '🇩🇰 Sportschef',
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&fit=crop&crop=faces',
  quote: 'Jeg købte det til min stab. Nu taler alle trænere i klubben samme sprog, og planlægningen hænger sammen.',
  highlight: 'Hele klubbens stab er forenet.'
}, {
  name: 'Sofie R.',
  role: '🇩🇰 U12 Træner',
  avatar: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=200&h=200&fit=crop&crop=faces',
  quote: 'Jeg troede, det bare var endnu en PDF. Jeg tog fejl. Det er et komplet, struktureret system, der kan bruges fra dag ét.',
  highlight: 'Kan bruges fra dag ét.'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-28 px-4 sm:px-6 relative overflow-hidden" data-id="element-249">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-primary/10 rounded-full blur-[120px] pointer-events-none" data-id="element-250"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-251">
        <div className="text-center mb-10 sm:mb-16" data-id="element-252">
          <span className="inline-block text-secondary font-bold text-xs sm:text-sm tracking-widest uppercase mb-3" data-id="element-253">
            ⭐ Hvad siger trænere i norden?
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight mb-4" data-id="element-254">
            +500 trænere har allerede{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-blue-400" data-id="element-255">
              fået deres tid tilbage
            </span>
          </h2>
          <div className="flex items-center justify-center gap-2 mt-4" data-id="element-256">
            <span className="text-secondary text-lg sm:text-xl drop-shadow-[0_0_8px_rgba(245,158,11,0.5)]" data-id="element-257">
              ⭐⭐⭐⭐⭐
            </span>
            <span className="text-text-sec text-sm sm:text-base font-medium" data-id="element-258">
              4.9/5 · Verificerede anmeldelser
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-259">
          {testimonials.map((t, i) => <motion.article key={t.name} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: i * 0.08,
          duration: 0.5
        }} className="bg-bg-alt border border-border-light rounded-2xl p-5 sm:p-7 flex flex-col h-full hover:border-primary/40 transition-colors shadow-[0_0_30px_rgba(0,0,0,0.2)]" data-id="element-260">
              <div className="text-secondary text-sm mb-3 drop-shadow-[0_0_6px_rgba(245,158,11,0.4)]" data-id="element-261">
                ⭐⭐⭐⭐⭐
              </div>

              <p className="text-text-main font-bold text-base sm:text-lg leading-snug mb-3" data-id="element-262">
                "{t.highlight}"
              </p>

              <p className="text-text-sec text-sm sm:text-base leading-relaxed mb-6 flex-1" data-id="element-263">
                {t.quote}
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-264">
                <img src={t.avatar} alt={t.name} loading="lazy" decoding="async" width={44} height={44} className="w-11 h-11 rounded-full object-cover border-2 border-primary/30" data-id="element-265" />
                <div className="min-w-0" data-id="element-266">
                  <div className="flex items-center gap-1.5" data-id="element-267">
                    <span className="text-text-main font-bold text-sm truncate" data-id="element-268">
                      {t.name}
                    </span>
                    <span className="text-primary text-xs flex-shrink-0" title="Verificeret køb" data-id="element-269">
                      ✓
                    </span>
                  </div>
                  <p className="text-text-sec text-xs truncate" data-id="element-270">{t.role}</p>
                </div>
              </div>
            </motion.article>)}
        </div>

        <div className="text-center mt-10 sm:mt-14" data-id="element-271">
          <a href="#pricing" className="inline-block bg-cta-green hover:bg-cta-green-hover text-white font-black text-base sm:text-xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl transition-all shadow-[0_0_30px_rgba(16,185,129,0.3)] border border-white/10" data-id="element-272">
            🚀 BLIV EN DEL AF DEM NU
          </a>
          <p className="text-text-sec text-xs sm:text-sm mt-3 font-medium" data-id="element-273">
            Øjeblikkelig adgang · 7 dages garanti
          </p>
        </div>
      </div>
    </section>;
}